import type { SupportedCountry } from '@archipro-website/localisation';
import {
    countriesList,
    DEFAULT_MARKET,
    isSupported,
} from '@archipro-website/localisation';

/**
 * Gets the domain name for a given country code.
 * The domain is sourced from the shared country config
 * (`packages/localisation`), which is the single source of truth, so new
 * markets are picked up automatically.
 * For old-stack, keep getDomain same as archipro2/javascript/common/helpers/links.ts
 *
 * @param countryCode The country code to get the domain for (AU, US, NZ)
 * @param withHttps Whether to include https:// prefix
 * @param pretty Whether to return the domain in a pretty format (ArchiPro.com.au, ArchiProAmerica.com, ArchiPro.co.nz)
 * @returns The domain name for the given country code
 */
export const getDomain = (
    countryCode: SupportedCountry,
    withHttps = false,
    pretty = false,
): string => {
    const country = isSupported(countryCode) ? countryCode : DEFAULT_MARKET;
    let domain = countriesList[country].domain;
    if (pretty) {
        domain = domain
            .replace('archiproamerica', 'ArchiProAmerica')
            .replace('archipro.', 'ArchiPro.');
    }
    return withHttps ? 'https://' + domain : domain;
};
